export default __webpack_public_path__ + "static/media/icon.pet food.c6ea22f1.svg";